import React, { Suspense, useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Viewport3D = React.lazy(() => import('./Viewport3D'));

function FeaturedCaseStudyCard({ projectModel: m, mountIndex = 0 }) {
  const [hovered, setHovered] = useState(false);
  const [viewportMounted, setViewportMounted] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const el = cardRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        obs.disconnect();
        setViewportMounted(true);
      }
    }, { rootMargin: '200px' });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Link
      to={m.pageUrl}
      ref={cardRef}
      className={`featured-cs-card${hovered ? ' model-hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={`featured-cs-image${m.splitScreen === false ? '' : ' featured-cs-split'}`}
        style={{ position: 'relative' }}
      >
        {m.splitScreen === false ? (
          <img src={m.imageUrl} alt={m.altDescription}
            style={{ width: '100%', height: 'auto', display: 'block', filter: hovered ? 'saturate(1.4) brightness(1.05)' : 'saturate(1) brightness(1)', transition: 'filter 0.3s ease' }} />
        ) : (
          <>
            <div className="featured-cs-split-left">
              <Suspense fallback={<div style={{ width: '100%', height: '100%', background: '#787878' }} />}>
                {viewportMounted && <Viewport3D shape={m.shape} hovered={hovered} hoverBg={m.rolloverColor} defaultBg={m.modelBg || '#787878'} />}
              </Suspense>
            </div>
            <div className="featured-cs-split-right">
              {m.imageUrl && <img src={m.imageUrl} alt={m.altDescription} style={{ width: '100%', height: 'auto', display: 'block', filter: hovered ? 'saturate(1.4) brightness(1.05)' : 'saturate(1) brightness(1)', transition: 'filter 0.3s ease' }} />}
            </div>
          </>
        )}
      </div>
      <div className="featured-cs-text">
        <div className="caption">{m.client}, <span style={{ textTransform: 'none' }}>{m.title}</span></div>
      </div>
    </Link>
  );
}

export default FeaturedCaseStudyCard;
